import Typography from "@/components/typography/Typography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { FC } from "react"
import "./LinedTitle.less"

const { Title } = Typography

type Props = {
  text: string
}

export const LinedTitle: FC<Props> = ({ text }) => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()

  return (
    <div className={"lined-title-wrapper"}>
      <div className={"lined-title-line lined-title-line-left"} />

      <Title level={xxl || xl || lg || md ? 3 : 5} centered color={"white"}>
        {text}
      </Title>

      <div className={"lined-title-line lined-title-line-right"} />
    </div>
  )
}
